module.exports = __webpack_public_path__ + "mobile/img/img_bg_arc_agent.27323d11.png";